const McitiImg = '/assets/img/physusLogo.png' // <-- adjust to your real path

const Footer = () => (
  <div className="footer fixed bottom-0 d-flex align-items-center justify-content-center gap-5 border-top bg-white px-4 py-2">
    <p className="mb-0 fw-medium ">Organized by IHFC (I-Hub Foundation for Cobotics), IIT Delhi</p>{"|"}
    <img
      src={McitiImg}
      alt="Mciti Logo"
      style={{ height: "55px", width: "55px", objectFit: "contain" }}
    />
  </div>
);

export default Footer;